// extracted by mini-css-extract-plugin
module.exports = {"YXHContractCheckSign":"index-module_YXHContractCheckSign_3sEOB","title":"index-module_title_3UL1I","idCard":"index-module_idCard_2nar6"};